<template>
  <div style="min-width:100%;">
    <div
      class="user-selection-container"
      style="min-width:100%;"
    >
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
        >
          <VAutocomplete
            v-model="userSelections"
            :items="siteUsers"
            :menuProps="{ maxHeight: '400' }"
            :label="$t('forms.labels.alType')"
            chips
            :clearable="!readOnly"
            multiple
            itemValue="value"
            itemText="chipText"
            data-cy="alertedUsers"
            outlined
            :readonly="readOnly"
            :searchInput.sync="search"
            :withCustomItemText="true"
          >
            <template
              #customItemText="{ item }"
            >
              <v-row>
                <v-list-item>
                  <v-list-item-icon style="align-self: center !important">
                    <v-icon v-if="isSelected(item.item)">
                      check_box
                    </v-icon>
                    <v-icon v-else>
                      check_box_outline_blank
                    </v-icon>
                  </v-list-item-icon>
                  <v-row align="center">
                    <v-col
                      cols="auto"
                      class="p-1"
                    >
                      <span>{{ item.item.fullName }}</span>
                    </v-col>
                    <v-col
                      cols="auto"
                      class="p-1"
                    >
                      <span style="font-style: italic; font-weight: 600">{{ `(${item.item.role})` }}</span>
                    </v-col>
                    <v-col
                      cols="auto"
                      class="p-1"
                    >
                      <span style="color: #8D969F">{{ item.item.email }}</span>
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-row>
            </template>
          </VAutocomplete>
        </v-col>
      </v-row>
      <AlertedUsers
        :usersList="selectedUsers"
        :alertedUsers="alertedPeopleList"
        :addedUsers="addedUsers"
        :deletedUsers="deletedUsers"
        @selectonChange="onAlertedUsersSelection"
      />
    </div>
  </div>
</template>
<script>
import { isEqual, difference } from 'lodash';
import AlertedUsers from '@/components/sites/AlertedUsers';
import roles from '@/constants/roles';
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete';

export default {
    components: {
        AlertedUsers,
        VAutocomplete,
    },
    props: {
        usersList: {
            type: Array,
            default: () => [],
        },
        alertedPeopleList: {
            type: Object,
            default: () => null,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            userSelections: [],
            search: '',
            addedUsers: [],
            deletedUsers: [],
        };
    },
    computed: {
        ...mapGetters([
            'hasRole',
        ]),
        siteUsers() {
            return this.usersList.map(user => ({
                name: user.fullName,
                chipText: `${user.fullName}(${user.email})`,
                email: user.email,
                role: user.role || 'Contact',
                value: user.memberId || user.contactId,
                disabled: false,
                divider: false,
            }));
        },
        selectedUsers() {
            const arr = this.userSelections.map(selection => {
                const user = this.usersList.find(x => (x.memberId || x.contactId) === selection);
                return user;
            }).filter(user => user);
            return arr;
        },
        isReadOnly() {
            return this.hasRole(roles.SALES_REPRESENTATIVE.value);
        },
    },
    watch: {
        alertedPeopleList: {
            immediate: true,
            handler(newValue, prevValue) {
                if (newValue?.initValue) {
                    if (!isEqual(newValue.initValue, prevValue?.initValue)) {
                        this.userSelections = newValue.initValue.map(val => val.memberId || val.contactId);
                    }
                }
            },
        },
        userSelections: {
            handler(newVal, oldVal) {
                const addedUsersId = difference(newVal, oldVal);
                const deletedUsersId = difference(oldVal, newVal);
                if (addedUsersId.length) {
                    this.addedUsers = this.usersList.filter(x => addedUsersId.find(id => x.memberId === id || x.contactId === id));
                }

                if (deletedUsersId.length) {
                    this.deletedUsers = deletedUsersId.filter(id => this.usersList.find(x => x.memberId === id || x.contactId === id));
                }
            },
        },
    },
    methods: {
        onAlertedUsersSelection(selectionObj, listIndex) {
            if (listIndex >= 0) {
                this.userSelections.splice(listIndex, 1);
            }
            this.$emit('onAlertedUsersSelectionChange', selectionObj);
        },
        isSelected(item) {
            return this.userSelections.includes(item.value);
        },
    },
};
</script>
